import { useCallback } from "react";

import { useAlert } from "@hl/base-components/lib/alert/useAlert";
import { logError } from "@hl/shared-features/lib/services/logger";

import { BlockchainEntity } from "components/BlockchainEntityTitle/types";
import { useToggleArchiveCollectionMutation } from "~/features/collections/sections/ContractCollectionDashboard/menu/menu.graphql.generated";
import { GetMergedCollectionByUserPaginatedDocument } from "~/features/tokens/queries/collections.graphql.generated";

export const useArchiveCollection = ({
  entity,
  onSuccess,
}: {
  entity: BlockchainEntity;
  onSuccess?: () => void;
}) => {
  const alert = useAlert();

  const [toggleArchiveMutation, { loading }] =
    useToggleArchiveCollectionMutation();

  const toggleArchive = useCallback(async () => {
    try {
      await toggleArchiveMutation({
        variables: {
          collectionId: entity.id,
        },
        refetchQueries: [GetMergedCollectionByUserPaginatedDocument],
      });
      onSuccess?.();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      alert.error("Error archiving collection");
      await logError({ error, message: "archive collection error" });
    }
  }, [toggleArchiveMutation, entity.id, alert]);
  return {
    toggleArchive,
    loading,
  };
};
